var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 141,
    viewBox: "0 0 676 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.672 41.7378C160.161 52.9499 148.044 63.8087 136.353 70.4999C148.044 77.1911 160.161 88.0498 172.672 99.262C195.312 119.552 219.244 141 244.283 141C245.068 141 245.849 140.987 246.628 140.961C247.407 140.987 248.19 141 248.975 141L605.611 141C644.486 141 676 109.436 676 70.5C676 31.564 644.486 0.000115916 605.611 0.000109108L248.975 4.66534e-05C248.19 4.65159e-05 247.408 0.0129155 246.63 0.0384544C245.85 0.0128847 245.068 6.87734e-08 244.283 0C219.244 -2.1924e-06 195.312 21.4475 172.672 41.7378Z",
    fill: "#F2F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.328 41.7378C112.839 52.95 124.956 63.8087 136.647 70.4999C124.956 77.1911 112.839 88.0498 100.328 99.262C77.6879 119.552 53.7561 141 28.7175 141C27.9332 141 27.1519 140.987 26.3738 140.961C25.5939 140.987 24.8109 141 24.0248 141L-332.611 141C-371.486 141 -403 109.436 -403 70.5001C-403 31.5641 -371.486 0.000215237 -332.611 0.000211833L24.0248 0.000180606C24.8091 0.000180537 25.5904 0.0130284 26.3685 0.0385255C27.1483 0.0129137 27.9314 7.81595e-06 28.7175 7.81595e-06C53.7561 7.81595e-06 77.6879 21.4475 100.328 41.7378Z",
    fill: "#F2F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftVector);
export default __webpack_public_path__ + "static/media/leftVector.8fa54ae69fd4b6d2ebf46a0d254aea0b.svg";
export { ForwardRef as ReactComponent };